module.exports = __webpack_public_path__ + "static/media/Wearing the Right Hat Video Script_1603745471658.ae60b725.docx";